import { Printer } from "./gen";
import { SecondScreenModel } from "../@models/second-screen.model";
import PrinterTypeEnum = Printer.PrinterTypeEnum;

export function isObjEmpty(obj: any): boolean {
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      return false;
    }
  }
  return true;
}

export function calculateRoundingAmount(amount: number) {
  let nearestCent = roundDecimal(amount);
  let rounding = nearestCent - amount;
  // Ensure rounding amount is displayed with exactly 2 decimal places
  return parseFloat(rounding.toFixed(2));
}

export function roundDecimal(number: number) {
  // Malaysian currency rounding to nearest 5 cents (0.05)
  // Multiply by 20 to convert 0.05 to 1, round, then divide back
  const roundedNumber = Math.round(number * 20) / 20;
  // Return the raw rounded number without premature toFixed to maintain precision
  return roundedNumber;
}

/**
 * Format amount for display with 2 decimal places
 * Internal calculations should use 4 decimals but UI displays 2
 */
export function formatCurrencyDisplay(amount: number): string {
  if (isNaN(amount) || amount === null || amount === undefined) {
    return '0.00';
  }
  return parseFloat(amount.toFixed(2)).toFixed(2);
}

/**
 * Convert amount to number with exactly 2 decimal places for UI display
 * Use this for values bound to UI templates
 */
export function toDisplayNumber(amount: number): number {
  if (isNaN(amount) || amount === null || amount === undefined) {
    return 0.00;
  }
  return parseFloat(amount.toFixed(2));
}

/**
 * Round amount for calculation/DB storage with 4 decimal precision
 * Use this for internal calculations to maintain precision
 */
export function roundForCalculation(amount: number): number {
  if (isNaN(amount) || amount === null || amount === undefined) {
    return 0;
  }
  return Math.round((amount + Number.EPSILON) * 10000) / 10000;
}

/**
 * Ensure monetary value has exactly 2 decimal places for UI display
 * This prevents 3-decimal issues and ensures consistent formatting
 */
export function formatMonetaryValue(amount: number): number {
  if (isNaN(amount) || amount === null || amount === undefined) {
    return 0.00;
  }
  return Math.round((amount + Number.EPSILON) * 100) / 100;
}

export function alignCenter(text, maxLength = 32) {
  const lines = text.split("\n");
  return lines.map((x) => `<C>${x}</C>`).join("\n");
}

export function alignCenter2(text, maxLength = 32) {
  const lines = text.split("\n");
  const centeredLines = lines
    .filter((line) => line)
    .map((line) => {
      const paddingLength = Math.floor((maxLength - line.length) / 2);
      const padding = paddingLength > 0 ? " ".repeat(paddingLength) : "";
      return padding + line;
    });
  return centeredLines.join("\n");
}

export function printz(
  printer: {
    printerName: string;
    printerType: PrinterTypeEnum;
    vendorId: string;
    ipAddress: string;
    macAddress: string;
    paperSizeType?: string;
  },
  textToPrints: string[] = [],
  type: "text" | "html" = "text"
) {
  if (window["ReactNativeWebView"]) {
    window["ReactNativeWebView"].postMessage(
      JSON.stringify({
        type: type === "text" ? "print" : "printHTML",
        payload: {
          printer: printer,
          data: [...textToPrints]
        }
      })
    );
  }
}

export function kickCashDrawerz() {
  if (window["ReactNativeWebView"]) {
    window["ReactNativeWebView"].postMessage(
      JSON.stringify({
        type: "kickCashDrawer"
      })
    );
  }
}

export function secondScreen(data: SecondScreenModel) {
  if (window["ReactNativeWebView"]) {
    window["ReactNativeWebView"].postMessage(
      JSON.stringify({
        type: "secondScreen",
        payload: { data: data }
      })
    );
  }
}

export function lcdScreen(data: string[] = []) {
  if (data.length > 0) {
    if (window["ReactNativeWebView"]) {
      window["ReactNativeWebView"].postMessage(
        JSON.stringify({
          type: "lcdScreen",
          payload: { data: data }
        })
      );
    }
  }
}

/**
 * only applicable for cloudinary service
 * @param originalURL
 * @param width 200
 * @param height 200
 */
export function resizeImageUrl(originalURL, width: string = "200", height: string = "") {
  let resizeAttr = "";
  if (width) {
    resizeAttr += "w_" + width;
  }
  if (height) {
    resizeAttr += "h_" + width;
  }
  return originalURL.replace("/upload/", "/upload/" + resizeAttr + "/");
}
